<template>
  <div>
    <CustomDialog ref='profile' :element='dialog.element.eleProfile' :styles='dialog.styles' :messages='dialog.messages.profile'>
      <template v-slot:dialog-content>
        <div>
          <ejs-grid ref='grid' :dataSource="data" height='100%' :pageSettings="page" :rowDeselected='getCheckedCount' :rowSelected='getCheckedCount' :allowReordering='true' :allowResizing='true'>
            <e-columns>
              <e-column field='profileId' :headerText='$t("Profile.profileId")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
              <e-column field='profileName' :headerText='$t("Profile.profileName")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
            </e-columns>
          </ejs-grid>
          <ejs-pager ref='pager' @click='qryList(ne)' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
        </div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>

import CustomDialog from '../../../../common/CustomDialog';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "ProfileList",
  components: {
    CustomDialog,
  },
  props: [
    'getCheckedDatas',
    'ne'
  ],
  methods: {
    qryList(ne) {
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          flag: 0,
        },
        info: {
          msgid: "17059",
          neid: ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };
      this.$axios.post(ajaxUrl.qryProfile, params).then((response) => {
        if (!response) {
          console.log("qryProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryProfile response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryProfile response.data.resultVal error");
          return;
        }
        const res = response.data.resultVal;
        if (res) {
          if (res.resultlist) {
            const resultlist = res.resultlist.map(item => {
              return {
                ...item,
              }
            });
            this.data = resultlist;
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countrsp;
          this.page.pageCount = Math.ceil(res.countrsp / this.page.pageSize);
        }
      });
    },
    show() {
      this.$refs.profile.show();
    },
    save() {
      const checkedKeys = this.getCheckedKeys();
      if(checkedKeys) {
        if(this.getCheckedDatas) {
          this.getCheckedDatas(checkedKeys);
        }
        this.close();
        return;
      }
    },
    close() {
      this.$refs.profile.clear();
      this.$refs.profile.close();
    },
    getCheckedRecords() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      return selectedRecords;
    },
    getCheckedKeys() {
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedRecords();
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push(checkedData[i].profileId);
      }
      return profileId.length === 0 ? null : profileId;
    },
    getCheckedCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.checkedCount = selectedRecords.length;
    },
  },
  data() {
    return {
      data: {},
      checkedCount: 0,
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      dialog: {
        styles: {
          width: '50%',
          height: '60%',
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          eleProfile: {
            target: this.$refs.Profile,
            refName: 'eleProfile',
            buttonGroup: [
              { click: this.close, buttonModel: { content: this.$t('SubscriberIms.cancel') } },
              { click: this.save, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true } }
            ],
            title: this.$t("Profile.RelatedProfile"),
            isClose: true,
          },
        },
        messages: {
          profile: {
            title: this.$t("Profile.RelatedProfile"),
          },
        },
      },
    };
  },
};
</script>
